export default __webpack_public_path__ + "11.05.2017-PMLifeTimebundesweit014985f5d8e62a04d387640091285af2.pdf";